import { replaceSpecialChars } from 'cpool-utils';
import { z } from 'zod';

export const schemaConsorsBirthName = z
    .string()
    .min(2)
    .transform(replaceSpecialChars)
    .transform((value) => value.replace(/\s{2,}/g, ' '))
    .transform((value) => value.slice(0, 27))
    .refine((value) => /^[A-Za-zÖÄÜäöüß]+([ -][0-9A-Za-zÖÄÜäöüß]+)*$/u.test(value), {
        message: 'Invalid characters',
    });
